<script lang="ts">
  import Icon from "@iconify/svelte";

  export let errorText: string = "";

  $: uppercaseErrorText = errorText.toUpperCase();
</script>

<div class="w-full h-full flex items-center justify-center gap-9">
  {#if errorText !== "MODERATION_REJECTION"}
    <Icon
      icon="material-symbols:error-outline"
      class="w-20 h-20 text-gray-200"
    />
  {/if}
  <div>
    {#if errorText !== "MODERATION_REJECTION"}
      <div class="text-center font-bold">Ein Fehler ist aufgetreten</div>
      <div class="text-center">
        Fehler: {uppercaseErrorText ? uppercaseErrorText : "UNKNOWN"}
      </div>
    {:else}
      <div class="font-bold">
        Eine Vereinfachung konnte nicht erstellt werden, da keine relevanten
        Inhalte gefunden wurden.
      </div>
    {/if}
  </div>
</div>
